import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Paintbrush } from 'lucide-react';

export function ColorPicker({ label, value, onChange, className = '' }) {
  const [showPicker, setShowPicker] = useState(false);

  const handleChange = (e) => {
    const newColor = e.target.value;
    onChange(newColor);
  };

  return (
    <div className={className}>
      {label && <Label className="text-xs text-slate-600 mb-1">{label}</Label>}
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <Input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="#2563EB"
            maxLength={7}
            className="pr-10"
          />
          <button
            type="button"
            onClick={() => setShowPicker(!showPicker)}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded border border-slate-300 flex items-center justify-center"
            style={{ backgroundColor: value || '#2563EB' }}
          >
            <Paintbrush className="w-3 h-3 text-white mix-blend-difference" />
          </button>
        </div>
        <input
          type="color"
          value={value || '#2563EB'}
          onChange={handleChange}
          className="w-12 h-10 rounded border border-slate-300 cursor-pointer"
        />
      </div>
      {showPicker && (
        <div className="mt-2 p-3 bg-slate-50 rounded border border-slate-200">
          <div className="text-xs text-slate-600 mb-2">Cores sugeridas:</div>
          <div className="grid grid-cols-8 gap-2">
            {[
              '#2563EB', '#10B981', '#F59E0B', '#EF4444',
              '#6366F1', '#8B5CF6', '#06B6D4', '#84CC16',
              '#1E40AF', '#059669', '#D97706', '#DC2626',
              '#4F46E5', '#7C3AED', '#0891B2', '#65A30D',
            ].map((color) => (
              <button
                key={color}
                type="button"
                onClick={() => {
                  onChange(color);
                  setShowPicker(false);
                }}
                className="w-8 h-8 rounded border-2 border-transparent hover:border-slate-400 transition-colors"
                style={{ backgroundColor: color }}
                title={color}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
